export class CloseAndRefreshDto {
    Close: boolean;
    Refresh: boolean;
}